import { ComponentProps, FunctionComponent } from "react";
import TableBase from "components/table-base";

interface TableProps extends ComponentProps<"table"> {}

const Table: FunctionComponent<TableProps> = ({ children }) => {
  return (
    <div>
      <div className="overflow-auto">
        <TableBase>{children}</TableBase>
      </div>
    </div>
  );
};

export default Table;
